export default function formTrimInput() {
  document.body.addEventListener("submit", event => {
    const form = event.target
    form.querySelectorAll("[data-trim-input]").forEach(el => {
      el.value = el.value.trim()
    })
  })
}
